module.exports = __webpack_public_path__ + "img/0e5cb8c.jpg";